<script setup>
// NOTICE: KAPTION-INTEGRATION
// reply-template-picker.BUTTON.1 / BUTTON.3 — "Plantilla" button in the reply
// box's top-right slot (Plantilla · gear · maximize). Teal while a template is
// loaded in the box.
import { useI18n } from 'vue-i18n';

defineProps({
  active: { type: Boolean, default: false },
});

const emit = defineEmits(['click']);
const { t } = useI18n();
</script>

<template>
  <button
    type="button"
    data-testid="reply-template-button"
    class="flex items-center gap-1 h-6 px-2 mt-3.5 mr-1 text-xs font-medium transition-colors rounded-lg shrink-0"
    :class="
      active
        ? 'bg-n-teal-3 text-n-teal-11 hover:bg-n-teal-4'
        : 'bg-n-alpha-2 text-n-slate-12 hover:bg-n-alpha-3'
    "
    :aria-pressed="active"
    :title="t('KAPTION_REPLY_TEMPLATE.BUTTON_TOOLTIP')"
    @click="emit('click')"
  >
    <span class="i-lucide-file-text size-3.5" />
    {{ t('KAPTION_REPLY_TEMPLATE.BUTTON') }}
  </button>
</template>
